module.exports = __webpack_public_path__ + "fonts/GT-Cinetype-Mono.ae3a0aad.woff";